<template>
  <v-navigation-drawer
    right
    fixed
    :value="showDrawer"
    hide-overlay
    stateless
    class="cart-drawer--drawer-box"
    :width="drawerWidth"
  >
    <!-- <v-toolbar flat>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">Service Order</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>-->

    <v-toolbar flat>
      <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->

      <v-toolbar-title>My Service Order</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="showCartDrawer(false)">
        <v-icon>close</v-icon>
      </v-btn>

      <!-- <v-btn icon>
        <v-icon>view_module</v-icon>
      </v-btn>-->
    </v-toolbar>

    <v-divider></v-divider>

    <v-list three-line class="pt-0 cart-drawer--item-list-box">
      <template v-for="(item, index) in cartProducts">
        <v-divider v-if="index > 0" :key="index"></v-divider>
        <v-list-tile @click>
          <!-- <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>-->

          <v-list-tile-content>
            <v-list-tile-title>{{item.title}}</v-list-tile-title>
            <v-list-tile-sub-title>Tk. {{item.price}}</v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-list-tile-title>Tk. {{item.price * item.cartQty}}</v-list-tile-title>
          </v-list-tile-action>
          <v-list-tile-action class="cart-drawer--action-box">
            <v-btn flat icon small @click="incrementDecrementItemQuantity({id: item.id, operator: '+'})">
              <v-icon small>add</v-icon>
            </v-btn>
            <v-avatar size="20" color="#DCDCDC" class="cart-drawer--item-qty">
              <span class="body-1">{{item.cartQty}}</span>
            </v-avatar>
            <v-btn flat icon small @click="incrementDecrementItemQuantity({id: item.id, operator: '-'})">
              <v-icon small>remove</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>

    <v-toolbar flat subheader height="145">
      <v-container grid-list-xs style="padding:0px;">
        <v-layout row wrap>
          <v-flex xs6>Subtotal</v-flex>
          <v-flex xs6 text-xs-right>tk. {{cartSummary.subTotal}}</v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6>Delivery fee</v-flex>
          <v-flex xs6 text-xs-right>tk. {{cartSummary.deliveryFee}}</v-flex>
        </v-layout>
        <v-layout row wrap class="body-2 mt-1">
          <v-flex xs6>Total</v-flex>
          <v-flex xs6 text-xs-right>tk. {{cartSummary.total}}</v-flex>
        </v-layout>
        <v-btn block color="secondary" dark class="mt-2">Place Order</v-btn>
      </v-container>
    </v-toolbar>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import VueScrollTo from "vue-scrollto";

export default {
  name: "CartDrawer",
  components: {},
  data() {
    return {
      // isOfferDialog: false,
      items: [
        { title: "Home", icon: "dashboard" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" },
        { title: "About", icon: "question_answer" }
      ],
      // right: null
      drawer: true
    };
  },
  computed: {
    drawerWidth: function() {
      const { xs, sm, width } = this.$vuetify.breakpoint;
      return xs || sm ? width : 350;
    },
    // ...mapState({
    //   isShowCartDrawer: state => state.cart.isShowCartDrawer
    // }),
    ...mapGetters("cart", {
      cartProducts: "cartProducts",
      cartTotalPrice: "cartTotalPrice",
      cartTotalQuantity: "cartTotalQuantity",
      showDrawer: "isShowCartDrawer",
      cartSummary: "cartSummary"
    })
  },
  methods: {
    ...mapActions("cart", ["showCartDrawer", "incrementDecrementItemQuantity"])
    // onClickPackageLearnMore() {
    //   this.isPricingTableModal = true;
    // },
  },
  created() {
    // this.$store.dispatch("products/getAllProducts");
  },
  watch: {
    showDrawer: function() {
      if (this.showDrawer) {
        document.documentElement.style.overflow = "hidden";
        return;
      }

      document.documentElement.style.overflow = "auto";
    }
  },
  mounted: function() {}
};
</script>

<style scoped>
.cart-drawer--item-qty {
  margin-top: 5px;
  font-weight: bold;
}
.cart-drawer--action-box {
  min-width: 26px !important;
}
.cart-drawer--drawer-box {
  overflow: hidden;
}
.cart-drawer--item-list-box {
  overflow: auto;
  height: calc(100% - 201px);
}
.cart-drawer--v-list-tile,
.cart-drawer--v-list-tile-content {
  height: 25px !important;
}
</style>